import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { healthCheck } from "../../services/services";

// Async thunk for health check
export const healthCheckAsync = createAsyncThunk(
  "health/check",
  async () => {
    const response = await healthCheck();
    return response;
  }
);

// Initial state
const initialState = {
  data: null,
  isLoading: false,
  isError: false,
  errorMessage: "",
};

// Slice
const healthCheckSlice = createSlice({
  name: "health",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(healthCheckAsync.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(healthCheckAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(healthCheckAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.error.message;
      });
  },
});

export default healthCheckSlice.reducer;
